import { usePaginatedAgentByConfigReference } from '@atlassian/conversation-assistant-agent/controllers/agents';
import type { Agent } from '@atlassian/conversation-assistant-service-api/types/assistance-service';

import { useAssistanceServiceParams } from '../../common/utils/use-assistance-service-params';

type PaginatedAgentsActionsWrappedProps = Omit<
	Parameters<typeof usePaginatedAgentByConfigReference>[0],
	'assistanceServiceParams'
> & {
	touchpointSource: string;
};

export const usePaginatedAgentByConfigReferenceWrapped = (
	props: PaginatedAgentsActionsWrappedProps,
): {
	getAndStoreAgentByExternalConfigReference: ({
		externalConfigReference,
	}: {
		externalConfigReference: string;
	}) => Promise<Agent | undefined>;
} => {
	const { touchpointSource, ...restProps } = props;
	const assistanceServiceParams = useAssistanceServiceParams({
		touchpointSource,
	});

	return usePaginatedAgentByConfigReference({
		...restProps,
		assistanceServiceParams,
	});
};
